import { Box, CircularProgress } from '@mui/material';
import { useGetMe } from '@/lib/api/me.ts';
import InvestorDashboard from './InvestorDashboard.tsx';
import { DashboardHeader } from '@/features/dashboard/components/DashboardHeader';
import QuickGuideDashboardSection from '@/features/quick-guide/QuickGuideDashboardSection';

export default function Dashboard() {
  const { data: user } = useGetMe();

  if (!user) {
    return (
      <Box sx={{ p: 3, display: 'flex', justifyContent: 'center' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (user.role === 'investor') {
    return <InvestorDashboard />;
  }

  return (
    <Box sx={{ p: { xs: 2, sm: 3, md: 4 }, minHeight: '100vh', background: '#ffffff' }}>
      <DashboardHeader title="Dashboard" />
      <QuickGuideDashboardSection />
    </Box>
  );
}
